export const build = { date:"2026-05-28.1435", stage:"alpha" }
